<template>
<div id="metro-destinations-editor">
    <div class="fieldsets-flex">    

    <fieldset>
        <legend>1. Kohdeasemat / laiturit</legend>
        <StationSelection :stations="stations"></StationSelection>
    </fieldset>

     <fieldset>
        <legend>2. Määränpäät</legend>
        <div class='station-selection'>
            <label>Määränpää</label>
            <SelectList :options="stationOptions('Asema')" @select="selectDestination" :searchable="true" :clearable="true" :value="0" :disabled="disabled" />
        </div>
        <div>
            <div v-for="d in selectedDestinations" :key="d.id" class='destination-change'> 
                <div class='fi'>{{ d.name }}</div>
                <div><b-form-input></b-form-input></div>
                <div class='se'>{{ d.name_se }}</div>
                <div><b-form-input></b-form-input></div>
                <div class='actions'><b-icon icon="x-square" class='remove' title='Poista' @click="deleteDestination(d.id)"></b-icon></div>
            </div>
        </div>
     
    </fieldset>

     <fieldset>
        <legend>3. Voimassaolo / esitysajat</legend>
        <ScheduleForm></ScheduleForm>
        
     </fieldset>
    </div>

    <t-button type="back" @click="close" :disabled="loading"></t-button> 
    
    <div style="float:right;">
        <!--btn v-if="type == 'update'" type="rm" @click="remove" :disabled="disabled"></btn--> 
        <t-button type="save" @click="save" :disabled="disabled"></t-button> 
    </div>
    
    <RequestInfo type="save" :loader="loading" :ok="ok"/>

</div>
</template>

<script>

import StationSelection from './StationSelection.vue';
import ScheduleForm from './ScheduleForm.vue';

export default ({
    props: ['item', 'stations', 'type'],
    components: { StationSelection, ScheduleForm },
    data: function() {
        return {
            disabled: false,
            loading: false,
            ok: false,
            selectedStations: [],
            selectedDestinations: []
        }
    },
    computed: {
        stationsAndPlatforms(){
            let list = [];
            for (var station of this.stations) {
                list.push( { id: station.id, name: station.name } );

                let platformCount = station.platforms ? station.platforms : 2;
                for (let i = 1; i <= platformCount; i++) {
                      list.push( { id: station.id + "." + i , name: station.name + " - Laituri " + i } );
                }
            }

            return list;
        }
    },
    
    methods: {
        stationOptions(label){
            var optionList = [];

            optionList.push(  { id: 0, label: label, icon: 'filter', caption: label } ); 
            for (var item of this.stations) {
                optionList.push({ id: item.id, label: item.name });
            }
            return optionList;
        },
       

        selectDestination(id){
             if(id){
                let destination = this.stations.find(station => station.id == id);
                if(destination)
                   this.selectedDestinations.push(destination); 
             }
        },
        deleteDestination(id){
           this.selectedDestinations = this.selectedDestinations.filter(d => d.id != id);
        },

        save(){
            this.disabled = this.loading = true;
            
            setTimeout(() => {
                this.loading = false; 
                this.ok = true; 
            }, 1000);
           
        },
      
        close(){
            this.$emit('close');
        }
    }

})
</script>